import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

// Whether "Move to Section" (return a field off the appendix) shows. Only the
// clinical single-page Diagnosis Evaluation offers this, for editable fields
// currently on the appendix.
export const useCanReturnFromAppendix = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();

  const appendixSupported =
    report.reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "single";
  const onAppendix = section.pageLocation === APPENDIX_PAGE_LOCATION;

  return appendixSupported && !isCompleted && !isReviewPage && onAppendix;
};
